import { MerchantMenuDto } from './merchant-menu.dto';
import { ProductMenuModifierDto } from './productMenuModifier.dto';

export class ProductMenuModifierSearchDto extends ProductMenuModifierDto {
  productId?: number;
  menu?: MerchantMenuDto;
}
